import React, { type FC, type ReactNode, useMemo, useState } from "react";
import { Cookies } from "react-cookie";

import { AIC_SELECTED_LANGUAGE_COOKIE_NAME } from "src/constants";

interface LanguageContextType {
  selectedLanguage: string;
  setSelectedLanguage: (language: string) => void;
}

const cookies = new Cookies();

const DEFAULT_LANGUAGE_CONTEXT: LanguageContextType = {
  selectedLanguage: cookies.get(AIC_SELECTED_LANGUAGE_COOKIE_NAME) || "en-US",
  setSelectedLanguage: () => {},
};

const LanguageContext = React.createContext<LanguageContextType>(
  DEFAULT_LANGUAGE_CONTEXT
);

export const useLanguage = () => React.useContext(LanguageContext);

export const LanguageContextProvider: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    cookies.get(AIC_SELECTED_LANGUAGE_COOKIE_NAME) || "en-US"
  );

  const contextValue = useMemo(
    () => ({
      selectedLanguage,
      setSelectedLanguage,
    }),
    [selectedLanguage]
  );

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};
